import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from 'app/models/location.model';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  apiUrl: string = `${environment.apiUrl}location`;
  constructor(private httpClient: HttpClient) { }

  public async getLocations(domainId: number){
    return await this.httpClient.get<Location[]>(this.apiUrl + `?domainId=${domainId}`).toPromise();
  }

  public saveLocation(location: Location){
    try {
      if(location.id){
        console.log('Actualizar ubicacion');
        return this.httpClient.put<Location>(this.apiUrl, location).pipe(
          catchError(this.handleError)
        );
      }else{
        console.log('Guardar nueva ubicacion');
        return this.httpClient.post<Location>(this.apiUrl, location).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
